'use client';

import { useEffect, useState } from 'react';

// CSS-only arbitrary variants (min-[375px]:) proved fragile when combined with
// arbitrary properties containing quotes (grid-template-areas). matchMedia
// gives an unambiguous, testable boundary that never leaks past 375px.
const NARROW_MOBILE_QUERY = '(max-width: 375px)';

export const useIsNarrowMobile = (): boolean => {
  const [isNarrow, setIsNarrow] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(NARROW_MOBILE_QUERY);
    const sync = () => setIsNarrow(mql.matches);
    sync();
    mql.addEventListener('change', sync);
    return () => mql.removeEventListener('change', sync);
  }, []);

  return isNarrow;
};
